import React, { useState } from 'react';
import Validator from 'validatorjs';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

const ComisionDelServicioForm = (props) => {
  const [, setValidator] = useState({
    isValid: false,
    validator: new Validator(),
  });

  const getRules = (data) => {
    return {
      Base: ['decimal:6'],
      Porcentaje: ['decimal:3'],
      Importe: ['required', 'decimal:6'],
    };
  };

  const handleOnChange = (event) => {
    const data = {
      ...props.data,
      ...event,
    };

    const validator = validate(data);

    props.onFormDataChange(
      {
        ComisionDelServicio: data,
      },
      {
        name: 'isValidComisionDelServicio',
        isValid: validator.passes(),
      }
    );
  };

  const validate = (data) => {
    const validator = new Validator(data, getRules(data));

    validator.check();

    setValidator({
      validator,
      isValid: validator.passes(),
    });

    return validator;
  };

  const { data = {} } = props;
  const rules = getRules(data);

  return (
    <Row>
      <Col
        sm
        md={4}
      >
        <FormControl
          type="number"
          label="Base"
          name="Base"
          placeholder=""
          help=""
          rules={rules.Base}
          value={data.Base}
          onChange={handleOnChange}
        />
      </Col>

      <Col
        sm
        md={4}
      >
        <FormControl
          type="number"
          label="Porcentaje"
          name="Porcentaje"
          placeholder=""
          help=""
          rules={rules.Porcentaje}
          value={data.Porcentaje}
          onChange={handleOnChange}
        />
      </Col>

      <Col
        sm
        md={4}
      >
        <FormControl
          type="number"
          label="Importe"
          name="Importe"
          placeholder=""
          help=""
          rules={rules.Importe}
          value={data.Importe}
          onChange={handleOnChange}
        />
      </Col>
    </Row>
  );
};

export default ComisionDelServicioForm;
